module.exports = new __parcel__URL__("error-state.7a6adba2.svg").toString();